import React from 'react';

const Currencies: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Base Currency</h1>
          <p className="text-gray-600 mt-2">
              Myanmar Curreny
          </p>
        </div>

        {/* Middle */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">View Base Currency</h1>
          <p className="text-gray-600 mt-2">
              Myanmar Curreny and other can add
          </p>
        </div>


        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/currency/currency1.png"
              alt="Users Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Currency</h2>
          <p className="text-gray-600 mb-4">
            Add another currency such as Baht, Singapore Dollar, US Dollar
          </p>
          <p className="text-gray-600 mb-4">
            To add a currency:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Currencies</li>
            <li>Click the New Currency button in the top right corner of the page.</li>
            <li>Fill the Name, Symbol and Decimal Places</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/currency/currency-new.png"
              alt="Add Currency Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Edit Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Currnecy</h2>
          <p className="text-gray-600 mb-4">
          After you have added a new currency, you can edit their data if required. Here’s how:
          </p>
          <ol className="list-disc list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings </li>
            <li>Select the role you want to edit and click down arrow button</li>
            <li>Click Edit.</li>
            <li>Make the required changes and click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/currency/currency-edit.jpg"
              alt="Add Custom Currency Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
          <div className="mb-6  mt-6">
            <img
              src="/images/settings/currency/currency-edit-save.png"
              alt="Currency Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default Currencies;
